// extracted by mini-css-extract-plugin
export var fileUpload = "_fg-1";
export var modalButton = "_fg-0";